import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  fetchProductReviews as fetchProductReviewsService, 
  fetchProductReviewsList, 
  fetchReviewVisuals as fetchReviewVisualsService,
  reviewAction as reviewActionService 
} from "./productReview.service";
import { ProductReviewResponse, ReviewListResponse, ReviewVisualsResponse, ReviewFilters } from "./productReview.types";
import { handleApiError } from "@/app/utils/handleApiError";

export const getProductReviews = createAsyncThunk<
  ProductReviewResponse,
  string,
  { rejectValue: string }
>(
  "productReview/getProductReviews",
  async (productSlug, { rejectWithValue }) => {
    try {
      const response = await fetchProductReviewsService(productSlug);
      return response;
    } catch (error) {
      return rejectWithValue(handleApiError(error));
    }
  }
);

export const getProductReviewsList = createAsyncThunk<
  ReviewListResponse,
  { productSlug: string; filters?: ReviewFilters },
  { rejectValue: string }
>(
  "productReview/getProductReviewsList",
  async ({ productSlug, filters }, { rejectWithValue }) => {
    try {
      const response = await fetchProductReviewsList(productSlug, filters);
      return response;
    } catch (error) {
      return rejectWithValue(handleApiError(error));
    }
  }
);

export const getReviewVisuals = createAsyncThunk<
  ReviewVisualsResponse,
  { productSlug: string; page?: number; perPage?: number },
  { rejectValue: string }
>(
  "productReview/getReviewVisuals",
  async ({ productSlug, page = 1, perPage = 20 }, { rejectWithValue }) => {
    try {
      const response = await fetchReviewVisualsService(productSlug, page, perPage);
      return response;
    } catch (error) {
      return rejectWithValue(handleApiError(error));
    }
  }
);

export const performReviewAction = createAsyncThunk<
  { reviewId: number; like_count: number; complaint_count: number; user_action: 'like' | 'complaint' | null },
  { reviewId: number; actionType: 'like' | 'complaint' },
  { rejectValue: string }
>(
  "productReview/performReviewAction",
  async ({ reviewId, actionType }, { rejectWithValue }) => {
    try {
      const response = await reviewActionService(reviewId, actionType);
      return { reviewId, ...response.data };
    } catch (error) {
      return rejectWithValue(handleApiError(error));
    }
  }
);